import { Box, Button, CircularProgress, Typography, useMediaQuery, useTheme } from "@mui/material";
import { BlobProvider, pdf, PDFDownloadLink } from "@react-pdf/renderer";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import PreferenceListPDF from "../Components/CollegePredictor/PreferenceListPDF";
import { getPredictedCollegesByCount } from "../services/CollegePredictorServices/aiCollegePredictorService";
import { sendPreferenceListEmail } from "../services/collegePredictorReportService";
const CollegePredictorReport = () => {

    const { state } = useLocation();
    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const [colleges, setColleges] = useState([]);
    const [emailSent, setEmailSent] = useState(false);
    let data = state?.filters;


    const sendPdfOnEmail = async () => {
        try {

            if (emailSent) return;

            const blob = await pdf(
                <PreferenceListPDF
                    filters={data}
                    colleges={colleges}
                />
            ).toBlob();

            await sendPreferenceListEmail({
                pdfBlob: blob,
                name: state?.name,
                email: state?.email
            });

            setEmailSent(true);

            console.log("Preference list emailed successfully.");

        } catch (err) {
            console.error("Email sending failed", err);
        }
    };
    const fetchCollegesByAI = async () => {
        if (!data?.rank) {
            return;
        }
        let aiObj = {
            rank: data.rank,
            branches: ["All"],
            category: "OPEN",
            category_gender_filter: "general",
            category_region_filter: "All",
            city: ["All"],
        }
        try {
            let datas = await getPredictedCollegesByCount("pcm", data.rank, data?.preferredBranch ?? ["All"], data?.category, data?.locationPreference ?? ["All"], data?.genderType, aiObj.category_region_filter);
            const datasorted = [...datas].sort(
                (a, b) => Number(a["Highest Rank"]) - Number(b["Highest Rank"])
            );

            setColleges(datasorted || []);
        } catch (error) {
            console.error("Error fetching colleges:", error);
        } finally {
            // setLoading(false);
        }
    }
    useEffect(() => {
        fetchCollegesByAI();
    }, [data]);
    useEffect(() => {
        if (colleges.length > 0 && emailSent == false) {
            sendPdfOnEmail();
        }
    }, [colleges]);

    if (!colleges) {
        return (
            <Box
                sx={{
                    position: "fixed",
                    inset: 0,
                    bgcolor: "rgba(255,255,255,.6)",
                    zIndex: 9999,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 2,
                }}
            >
                <CircularProgress />

                <Typography variant="h6" align="center">
                    Preference List is also being sent to your email.
                </Typography>
            </Box>
        )
        // return <Navigate to="/" replace />;
    }

    return (
        colleges?.length > 0 ?
            (<Box
                sx={{
                    width: "100%",
                    height: "100vh",
                    background: "#f5f5f5",
                    overflow: "hidden"
                }}
            >
                {isMobile ? (
                    <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        height="100%"
                    >
                        <PDFDownloadLink
                            document={
                                <PreferenceListPDF
                                    filters={data}
                                    colleges={colleges}
                                />
                            }
                            fileName="Preference-List.pdf"
                            style={{ textDecoration: "none" }}
                        >
                            {({ loading }) =>
                                loading ? (
                                    <CircularProgress />
                                ) : (
                                    <Button variant="contained" size="large">
                                        Download Preference List
                                    </Button>
                                )
                            }
                        </PDFDownloadLink>
                    </Box>
                ) : (
                    <BlobProvider
                        document={
                            <PreferenceListPDF
                                filters={data}
                                colleges={colleges}
                            />
                        }
                    >
                        {({ url, loading }) =>
                            loading ? (
                                <CircularProgress />
                            ) : (
                                <iframe
                                    src={url}
                                    width="100%"
                                    height="100%"
                                    style={{ border: 0 }}
                                />
                            )
                        }
                    </BlobProvider>
                )}
                {/* <PDFViewer
                    width="100%"
                    height="100%"
                    showToolbar
                >
                    <PreferenceListPDF
                        filters={data}
                        colleges={colleges}
                    />
                </PDFViewer> */}
            </Box>)
            : (
                <Box
                    sx={{
                        position: "fixed",
                        inset: 0,
                        bgcolor: "rgba(255,255,255,.6)",
                        zIndex: 9999,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 2,
                    }}
                >
                    <CircularProgress />

                    <Typography variant="h6" align="center">
                        Preference List is also being sent to your email.
                    </Typography>
                </Box>
            )
    );
};

export default CollegePredictorReport;